import * as React from "react";
import { CreditCard, Truck, RefreshCcw, Mail, MessageCircleQuestionMark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
const categories = [{
  id: "booking",
  title: "Booking & Events",
  icon: CreditCard
}, {
  id: "experience",
  title: "The Experience",
  icon: Truck
}, {
  id: "logistics",
  title: "Service Areas",
  icon: RefreshCcw
}];
const faqs = [{
  id: "p1",
  categoryId: "booking",
  question: "How do I reserve a date for my event?",
  answer: "To secure your date, simply fill out our inquiry form. We require a signed contract and a 50% non-refundable retainer to officially add your celebration to our floral calendar."
}, {
  id: "p2",
  categoryId: "booking",
  question: "What is your cancellation policy?",
  answer: "We understand plans change. Cancellations made 30 days prior to the event will not be charged the remaining balance. The initial retainer remains non-refundable due to floral sourcing commitments."
}, {
  id: "p3",
  categoryId: "booking",
  question: "Do you offer custom floral themes?",
  answer: "Absolutely! We work closely with you to select a color palette and bloom variety that perfectly complements your wedding, shower, or corporate brand aesthetic."
}, {
  id: "s1",
  categoryId: "experience",
  question: "How long does the flower bar setup take?",
  answer: "We typically arrive 60-90 minutes before your event starts to ensure the bar is perfectly styled and the blooms are fresh and ready for your guests to enjoy."
}, {
  id: "s2",
  categoryId: "experience",
  question: "Are guests guided on how to build bouquets?",
  answer: "Yes! Our professional floral hosts are on-site to assist guests in selecting complementary stems and providing tips on how to wrap and care for their custom creations."
}, {
  id: "r1",
  categoryId: "logistics",
  question: "Where do you provide mobile flower bar services?",
  answer: "We proudly serve Clarksville, Nashville, Fort Campbell, Hopkinsville, and surrounding areas in Middle Tennessee and Southern Kentucky. Travel fees may apply for locations outside a 30-mile radius."
}, {
  id: "r2",
  categoryId: "logistics",
  question: "Can the flower bar be set up outdoors?",
  answer: "Yes, as long as there is a flat surface and protection from extreme heat or direct sunlight to keep our delicate blooms looking their absolute best throughout your event."
}];
export default function PackageFaq() {
  return <section data-section-id="224891" id="package-faq" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        
        {}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center p-3 bg-secondary/10 rounded-lg mb-4">
            <MessageCircleQuestionMark className="size-6 text-secondary" />
          </div>
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight mb-4 text-soft-rose">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Everything you need to know about bringing the Babe Bloom Bar experience to your next luxury celebration.
          </p>
        </div>

        {}
        <div className="space-y-12">
          {categories.map((category, i) => {
          const categoryFaqs = faqs.filter(faq => faq.categoryId === category.id);
          const Icon = category.icon;
          return <div key={category.id} data-index={i} className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-secondary/20">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-secondary/10">
                  <div className="p-2 bg-secondary/10 rounded-lg">
                    <Icon className="lucide lucide-credit-card size-5 text-primary" />
                  </div>
                  <h3 className="font-default text-xl font-semibold text-blush-pink">
                    {category.title}
                  </h3>
                </div>

                <Accordion type="single" collapsible className="w-full">
                  {categoryFaqs.map((faq, j) => <AccordionItem key={faq.id} value={faq.id} data-index={j} className="border-secondary/10 last:border-0">
                      <AccordionTrigger className="text-left font-default font-medium text-base text-cream hover:text-primary transition-colors py-4">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-soft-rose leading-relaxed pb-5 font-default">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>)}
                </Accordion>
              </div>;
        })}
        </div>

        {}
        <div className="mt-16 text-center bg-accent/10 rounded-xl p-8 border border-secondary/30 backdrop-blur-sm">
          <h4 className="font-default text-xl font-semibold mb-2 text-white">
            Still have questions?
          </h4>
          <p className="text-muted-foreground mb-6 max-w-md mx-auto font-default">
            Our team is here to help you curate the perfect floral experience for your guests.
          </p>
          <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs h-10 has-[>svg]:px-4 rounded-lg px-8 bg-primary hover:bg-accent transition-all duration-300 text-primary-foreground">
            <Link to="/ContactPage">
              <Mail className="mr-2 size-4" />
              Contact Our Team
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}